import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const MenuIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.957895C0 0.703845 0.100921 0.460201 0.280561 0.280561C0.460201 0.100921 0.703845 0 0.957895 0H18.2C18.4541 0 18.6977 0.100921 18.8773 0.280561C19.057 0.460201 19.1579 0.703845 19.1579 0.957895C19.1579 1.21194 19.057 1.45559 18.8773 1.63523C18.6977 1.81487 18.4541 1.91579 18.2 1.91579H0.957895C0.703845 1.91579 0.460201 1.81487 0.280561 1.63523C0.100921 1.45559 0 1.21194 0 0.957895ZM0 6.73592C0 6.48187 0.100921 6.23822 0.280561 6.05858C0.460201 5.87894 0.703845 5.77802 0.957895 5.77802H18.2C18.4541 5.77802 18.6977 5.87894 18.8773 6.05858C19.057 6.23822 19.1579 6.48187 19.1579 6.73592C19.1579 6.98996 19.057 7.23361 18.8773 7.41325C18.6977 7.59289 18.4541 7.69381 18.2 7.69381H0.957895C0.703845 7.69381 0.460201 7.59289 0.280561 7.41325C0.100921 7.23361 0 6.98996 0 6.73592ZM0.957895 11.557C0.703845 11.557 0.460201 11.6579 0.280561 11.8376C0.100921 12.0172 0 12.2608 0 12.5149C0 12.7689 0.100921 13.0126 0.280561 13.1922C0.460201 13.3719 0.703845 13.4728 0.957895 13.4728H18.2C18.4541 13.4728 18.6977 13.3719 18.8773 13.1922C19.057 13.0126 19.1579 12.7689 19.1579 12.5149C19.1579 12.2608 19.057 12.0172 18.8773 11.8376C18.6977 11.6579 18.4541 11.557 18.2 11.557H0.957895Z"
        fill="#363B3E"
      />
    </svg>
  );
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

MenuIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default MenuIcon;
